export default __webpack_public_path__ + "static/media/button-tablet.7fbf01ec.png";